import { render, staticRenderFns } from "./PartnerName.vue?vue&type=template&id=76e3fbb8&scoped=true"
import script from "./PartnerName.vue?vue&type=script&lang=js"
export * from "./PartnerName.vue?vue&type=script&lang=js"
import style0 from "./PartnerName.vue?vue&type=style&index=0&id=76e3fbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3fbb8",
  null
  
)

export default component.exports